import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '../../components/modal/modal';
import {AppSettings} from '../../constants';
import { SimpleDataTable } from '../../components/data-table/simple-data-table';
import { MessengerBox } from '../../components/messenger-box/messenger-box';
import { ContextMenu } from '../../components/context-menu/context-menu';
import * as CommonActionType from '../../Common/constants';
import * as ModelActionType from '../constants';
import * as RoomActionType from '../../Rooms/constants';
import { Dropdown } from '../../components/Dropdown/Dropdown';
import '../model.css';

export class RoomModel extends Component {

  static propTypes = {
    errorMsg: PropTypes.array,
    selectListRooms: PropTypes.array,
    isOpenPopUpRoomModel: PropTypes.bool,
    manageRoomsModels: PropTypes.object,
    onCloseRoomModal: PropTypes.func
  }
  constructor(props) {
    super(props);
    this.state = {
      modelId: null,
      modelName: '',
      disabled: true,
      parentProps: null,
      errorMsg: '',
      columns: [
        {
          title: 'Location name',
          name: 'name'
        },{
          title: 'Dimensions',
          name: 'dimension'
        }
        // }, {
        //   title: '',
        //   name: '',
        //   customRender: this.customRenderBtnAction.bind(this),
        //   className: 'cls-colm-action'
        // }
      ]
    };
    this.onBindRoomModel = this._onBindRoomModel;
  }

  componentDidMount() {

  }

  componentWillReceiveProps(nextProps) {

    this.setState({ errorMsg: nextProps.errorMsg[0] });

    if (nextProps.errorMsg.length === 0 && this.form) {
      this.room.reset();

      this.setState({ disabled: true });
    }

  }

  componentWillUnmount() {
    this.setState({});
  }

  customRenderBtnAction(item) {
    return <a className='glyphicon glyphicon-option-vertical cls-table-black-icon' onClick={(e) => { this.onContextMenu(e, item); }} />;
  }

  onContextMenu(e, item) {

    var contextItem = [{
      title: 'Remove',
      icon: 'glyphicon glyphicon-share-alt',
      event: this.onRemove.bind(this)
    }];

    this.cxtMenu.state.event(e, item, contextItem, (elm, left, top) => {
      elm.root.style.left = '380px';
      elm.root.style.top = `${top - 14}px`;
    });
  }

  onRemove(e, item) {
    this.onSave({ modelId: this.state.modelId, roomId: item.id }, ModelActionType.REMOVE_ROOM_OUT_OF_MODEL_ASYNC);
  }

  _onBindRoomModel(parentProps, modelId, modelName) {

    this.setState({ parentProps: parentProps, modelId: modelId, modelName: modelName });

    setTimeout(() => { this.binding(this.objToParams(this.props.manageRoomsModels.params)); });
  }

  binding(params) {

    this.state.parentProps.dispatch({
      type: ModelActionType.SEARCH_ROOM_MODEL_ASYNC,
      params: params
    });
  }

  objToParams(obj) {
    return {
      modelId: this.state.modelId,
      name: '',
      sortField: obj.sort.field,
      sortOrder: obj.sort.order,
      skip: obj.skip - 1,
      take: obj.take
    };
  }

  onTableBinding(configTable) {
    this.binding({
      ...this.objToParams(this.props.manageRoomsModels.params),
      sortField: configTable.sort.field,
      sortOrder: configTable.sort.order,
      skip: configTable.page.skip - 1,
      take: configTable.page.take
    });
  }

  onSelected() {

    this.setState({ disabled: false });
  }

  onSave(param, modelActionType) {
    this.state.parentProps.dispatch({
      type: modelActionType,
      params: {
        data: param,
        search: this.objToParams(this.props.manageRoomsModels.params)
      },
      callback: () => {
        this.setState({room: null});
      }
    });
  }

  onAdd() {

    this.onSave({
      modelId: this.state.modelId,
      roomId: this.state.room.value
    }, ModelActionType.ADD_ROOM_TO_MODEL_ASYNC);

  }

  onBindingRooms(item) {
    this.state.parentProps.dispatch({
      type: RoomActionType.SELECT_LIST_ROOM_ASYNC,
      params: {
        param: { isAll: false, searchKey: item.searchKey || '', selectedValue: item.selectedValue || '' },
        nextAction: [
          { action: CommonActionType.COMMON_SELECT_LIST_ROOM_SUCCESS, params: null }
        ]
      }
    });
  }

  renderTableRooms() {

    return <div>
      <SimpleDataTable
        columns={this.state.columns}
        items={this.props.manageRoomsModels.items}
        configTable={this.props.manageRoomsModels.defaultRoomModelParams}
        onTableBinding={this.onTableBinding.bind(this)} />
    </div>;
  }

  onSelectChange = (event, name) => {
    this.setState({
      [name]: event.value,
      disabled: false
    });
  }

  onCloseRoomModal = () => {
    this.props.onCloseRoomModal();
  }

  render() {
    return <Modal isOpen={this.props.isOpenPopUpRoomModel}>
      <div className='modal-header'>
        <h5 className='modal-title'>Location for plan <b>{this.state.modelName}</b></h5>
        <button type='button' className='close' onClick={this.onCloseRoomModal} aria-label='Close'>
          <span aria-hidden='true'>&times;</span>
        </button>
      </div>
      <div className='modal-body'>
        <div className='form-group row'>
          <label htmlFor='staticEmail'
            className='col-sm-4 col-form-label'
            style={{ 'marginRight': '-50px', 'marginTop': '10px' }}>Location name <span className='text-danger'>*</span>
          </label>
          <div className='col-md-6'>
            <Dropdown
              onChange={ref => { this.onSelectChange(ref, 'room'); }}
              className='filestring-dropdown filter-dropdown'
              options={this.props.selectListRooms}
              optionLabel='text'
              onRemote={this.onBindingRooms.bind(this)}
              value={this.state.room}
              filter
              placeholder='Please select'
              style={{ display: 'inline-block', width: '100%', marginBottom: 0}} />
            <span className='cls-danger help-block'>{this.props.errorMsg.error}</span>
          </div>
          <div className='col-md-3'>
            <button
              className='btn btn-primary btn-siteone'
              disabled={this.state.disabled}
              onClick={this.onAdd.bind(this)}>Add</button>
          </div>
        </div>
        <div className='form-group'>
          <h5 style={{ 'marginBottom': '15px' }}>Locations</h5>
          {this.renderTableRooms()}
          <ContextMenu ref={(ref) => { this.cxtMenu = ref; }} />
          <MessengerBox ref={(ref) => { this.msgBox = ref; }} title={AppSettings.COMPANY_NAME} />
        </div>

      </div>
    </Modal>;
  }
}



// WEBPACK FOOTER //
// ./src/Model/Containers/room-model.js